window.process = window.process || {};
window.global ||= window;
